import {Component, Module} from 'app/decorators';


@Module({
    name: "app.directives.nodata",
})
@Component({
    selector: 'no-data',
    transclude: true,
    bindings: {
        params: '=',  // ngTable params
        condition: '<',
    },
    template: '<div class="no-data" ng-show="$ctrl.condition || (!$ctrl.params.settings().$loading && $ctrl.params.total() === 0)" ng-transclude>No data</div>',
})
export default class C {
}



// WEBPACK FOOTER //
// ./src/app/directives/nodata.js